<div [id]="buttonTooltip?.id" class="vw-scale w-[fit-content] fixed-pos-tooltip {{ additionalClasses }}">
  <a
    data-qa="app-button-a"
    class="flex flex-row items-center h-[100%] button {{ bordersSquaredShape }} {{ type }} {{ size }}"
    [class.button-disabled]="disabled"
    [class.sq]="showIcon === 'only'"
    [class.row-gap-0p375]="showSpinner && spinnerButtonClicked"
    (click)="buttonClickEmitter()"
  >
    @if (buttonTooltip?.showCondition) {
      <div class="fms-tooltip fixed-pos-tooltip-container !top-[-1.7rem]">
        <div class="fms-tooltip-body w-max" [style.left]="buttonTooltip.xShift"> {{ buttonTooltip?.text }}</div>
      </div>
    }
    @if (iconName?.length && (showIcon === 'left' || showIcon?.includes('only'))) {
      <svg class="{{ iconSize }} flex flex-row items-center justify-center flex00auto">
        <use
          [attr.xlink:href]="iconPath + '#img'"
          [attr.href]="iconPath + '#img'">
        </use>
      </svg>
    }
    <div class="text">
      <ng-content></ng-content>
    </div>
    @if (iconName?.length && showIcon === 'right') {
      <svg class="{{ iconSize }} flex flex-row items-center justify-center flex00auto">
        <use
          [attr.xlink:href]="iconPath + '#img'"
          [attr.href]="iconPath + '#img'">
        </use>
      </svg>
    }
    @if (showSpinner) {
      <div #spinnerDiv [ngClass]="{'w-[1rem]': spinnerButtonClicked}" class="button-spinner-container"></div>
    }
  </a>
</div>
